import clsx from 'clsx'

import { Icon } from '@wartek-id/icon-v2'
import { Text } from '@wartek-id/text-v1'

import type { TAtasanStatus } from 'types/kinerja-atasan'
import type { FC } from 'react'

type TStyle = Exclude<TAtasanStatus, 'UNCONFIRMED'> | 'UNKNOWN'

type DialogConcentSummaryProps = {
  value?: TStyle
  title: string
  label: string
  labelValue: string | React.ReactNode
}

const values: Record<TStyle, any> = {
  CONFIRMED: {
    className: 'bg-green-5',
    icon: 'check_circle_outline',
    postfix: 'benar',
  },
  REJECTED: {
    className: 'bg-red-5',
    icon: 'highlight_off_outline',
    postfix: 'salah',
  },
  UNKNOWN: {
    className: 'bg-gray-5',
    icon: 'help_outline',
    postfix: 'tidak ada',
  },
}

const BlockValue = ({ labelValue }) => {
  if (labelValue === null) {
    return (
      <Text className="flex-1 text-right truncate" title="-">
        -
      </Text>
    )
  }

  if (typeof labelValue === 'string') {
    return (
      <Text className="flex-1 text-right truncate" title={labelValue}>
        {labelValue}
      </Text>
    )
  }

  return labelValue
}

export const DialogConsentSummary: FC<DialogConcentSummaryProps> = ({
  value = 'UNKNOWN',
  title,
  label,
  labelValue,
}) => {
  const finalValue = value || 'UNKNOWN'

  return (
    <div
      className={clsx('p-4 space-y-3 rounded', values?.[finalValue]?.className)}
    >
      <div className="flex flex-row gap-2 items-center justify-start">
        <Icon>{values?.[finalValue]?.icon}</Icon>
        <Text className="!font-bold">
          {title} {values?.[finalValue]?.postfix}
        </Text>
      </div>
      <div className="flex flex-row gap-2 items-center justify-between">
        <Text className="flex-1">{label}</Text>
        <BlockValue labelValue={labelValue} />
      </div>
    </div>
  )
}
